import {
  ALTERNATIVE_DICE_PATH_NAME,
  BACCARAT_PATH_NAME,
  BLACK_JACK_PATH_NAME,
  COIN_FLIP_PATH_NAME,
  CRASH_PATH_NAME,
  DICE_PATH_NAME,
  DOUBLE_DICE_PATH_NAME,
  DRIFT_PATH_NAME,
  FAST_TRADE_PATH_NAME,
  FISHING_PATH_NAME,
  FOOTBALL_PATH_NAME,
  HANDS_BLACKJACK_PATH_NAME,
  HILO_PATH_NAME,
  KENO_PATH_NAME,
  LIMBO_10_PATH_NAME,
  LIMBO_PATH_NAME,
  MINES_PATH_NAME,
  PLINKO_PATH_NAME,
  POWER_OF_GODS_PATH_NAME,
  ROULETTE_PATH_NAME,
  TOWER_PATH_NAME,
  WHEEL_PATH_NAME,
} from './socketPathName';
import { LimboSoundsName, LimboSoundsPath } from '../../games/limbo/limboCore/constants';
import { MinesSoundsName, MinesSoundsPath } from '../../games/mines/minesCore/constants';
import { DiceSoundsName, DiceSoundsPath } from '../../games/dice/diceCore/constants';
import { CrashSoundsName, CrashSoundsPath } from '../../games/crash/crashCore/constants/sounds';
import { WheelSoundsPath } from '../../games/wheel/wheelCore/constants';
import { DriftSoundNames, DriftSoundsPath } from '../../games/drift/driftCore/constants/sounds';
import {
  BaccaratSoundsName,
  BaccaratSoundsPath,
} from '../../games/baccarat/baccaratCore/constants/sounds';
import {
  FootballSoundsName,
  FootballSoundsPath,
} from '../../games/football/footballCore/constants/sounds';
import {
  FishingSoundsName,
  FishingSoundsPath,
} from '../../games/fishing/fishingCore/constants/sounds';
import { HiloSoundsName, HiloSoundsPath } from '../../games/hilo/hiloCore/constants/sounds';
import {
  CoinFlipSoundsName,
  CoinFlipSoundsPath,
} from '../../games/coinFlip/coinFlipCore/constants/sounds';
import {
  RouletteSoundsName,
  RouletteSoundsPath,
} from '../../games/roulette/rouletteCore/constants/sounds';
import {
  BlackJackSoundsName,
  BlackJackSoundsPath,
} from '../../games/blackjack/blackJackCore/constants/sounds';
import { KenoSoundsName, KenoSoundsPath } from '../../games/keno/kenoCore/constants/sounds';
import {
  AlternativeDiceSoundsName,
  AlternativeDiceSoundsPath,
} from '../../games/alternativeDice/alternativeDiceCore/sounds';
import { PlinkoSoundNames, PlinkoSoundPath } from '../../games/plinko/plinkoCore/constants/sounds';
import {
  DoubleDiceSoundsName,
  DoubleDiceSoundsPath,
} from '../../games/doubleDice/doubleDiceCore/constants';
import { Limbo10SoundsName, Limbo10SoundsPath } from '../../games/limbo10/limbo10Core/constants';
import {
  FastTradeSoundsName,
  FastTradeSoundsPath,
} from '../../games/fastTrade/fastTradeCore/constants';
import {
  HandBlackJackSoundsName,
  HandBlackJackSoundsPath,
} from '../../games/handBlackjack/handBlackjackCore/constants/sounds';
import { TowerSoundsName, TowerSoundsPath } from '../../games/tower/towerCore/constants/sounds';
import {
  PowerOfGodsSounds,
  PowerOfGodsSoundsNames,
} from '../../games/powerOfGods/powerOfGodsCore/constants/globalConstants';

export const SoundTypesByGame = {
  [LIMBO_PATH_NAME]: LimboSoundsName,
  [MINES_PATH_NAME]: MinesSoundsName,
  [DICE_PATH_NAME]: DiceSoundsName,
  [CRASH_PATH_NAME]: CrashSoundsName,
  [DRIFT_PATH_NAME]: DriftSoundNames,
  [BACCARAT_PATH_NAME]: BaccaratSoundsName,
  [FISHING_PATH_NAME]: FishingSoundsName,
  [FOOTBALL_PATH_NAME]: FootballSoundsName,
  [HILO_PATH_NAME]: HiloSoundsName,
  [COIN_FLIP_PATH_NAME]: CoinFlipSoundsName,
  [ROULETTE_PATH_NAME]: RouletteSoundsName,
  [BLACK_JACK_PATH_NAME]: BlackJackSoundsName,
  [KENO_PATH_NAME]: KenoSoundsName,
  [PLINKO_PATH_NAME]: PlinkoSoundNames,
  [ALTERNATIVE_DICE_PATH_NAME]: AlternativeDiceSoundsName,
  [DOUBLE_DICE_PATH_NAME]: DoubleDiceSoundsName,
  [LIMBO_10_PATH_NAME]: Limbo10SoundsName,
  [FAST_TRADE_PATH_NAME]: FastTradeSoundsName,
  [HANDS_BLACKJACK_PATH_NAME]: HandBlackJackSoundsName,
  [TOWER_PATH_NAME]: TowerSoundsName,
  [POWER_OF_GODS_PATH_NAME]: PowerOfGodsSoundsNames,
};

export const SoundOptionsByGame = {
  [LIMBO_PATH_NAME]: LimboSoundsPath,
  [MINES_PATH_NAME]: MinesSoundsPath,
  [DICE_PATH_NAME]: DiceSoundsPath,
  [HILO_PATH_NAME]: HiloSoundsPath,
  [ALTERNATIVE_DICE_PATH_NAME]: AlternativeDiceSoundsPath,
  [PLINKO_PATH_NAME]: PlinkoSoundPath,
  [ROULETTE_PATH_NAME]: RouletteSoundsPath,
  [KENO_PATH_NAME]: KenoSoundsPath,
  [WHEEL_PATH_NAME]: WheelSoundsPath,
  [CRASH_PATH_NAME]: CrashSoundsPath,
  [COIN_FLIP_PATH_NAME]: CoinFlipSoundsPath,
  [FOOTBALL_PATH_NAME]: FootballSoundsPath,
  [DRIFT_PATH_NAME]: DriftSoundsPath,
  [FISHING_PATH_NAME]: FishingSoundsPath,
  [BLACK_JACK_PATH_NAME]: BlackJackSoundsPath,
  [BACCARAT_PATH_NAME]: BaccaratSoundsPath,
  [DOUBLE_DICE_PATH_NAME]: DoubleDiceSoundsPath,
  [LIMBO_10_PATH_NAME]: Limbo10SoundsPath,
  [FAST_TRADE_PATH_NAME]: FastTradeSoundsPath,
  [HANDS_BLACKJACK_PATH_NAME]: HandBlackJackSoundsPath,
  [TOWER_PATH_NAME]: TowerSoundsPath,
  [POWER_OF_GODS_PATH_NAME]: PowerOfGodsSounds,
};
